<template>

    <template v-if="activeBulkItem.component === 'DeleteFilesButton'">
        <DeleteFilesButton
            class="m-2"
            :rounded-edges="true"
            :files-to-delete="soundIds"
            :requesting-user="requestingUser"
            @files-deleted="actionComplete(activeBulkItem.name, $event)">
        </DeleteFilesButton>
    </template>

    <template v-else-if="activeBulkItem.component === 'MlRequestOptions'">
        <MlRequestOptions
            :sound-ids="soundIds"
            :requesting-user="requestingUser"
            :token="token"
            :always-show="true"
            @ml-req-complete="actionComplete(activeBulkItem.name, $event)">
        </MlRequestOptions>
    </template>

    <template v-else-if="activeBulkItem.component === 'BulkEdit'">
        <BulkEdit
            :sound-ids="soundIds"
            :requesting-user="requestingUser"
            :token="token"
            @bulk-edit-complete="actionComplete(activeBulkItem.name, $event)">
        </BulkEdit>
    </template>

    <template v-else>
        <p>
            Something went wrong. If the problem persists, please 
            contact Wilder Sensing admins at info@wildersensing.com
        </p>
    </template>

</template>

<script>
import MlRequestOptions from '@/components/sounds/sound-details/MlRequestOptions.vue'
import DeleteFilesButton from '@/components/sounds/bulk-actions/DeleteFilesButton.vue'
import BulkEdit from '@/components/sounds/bulk-actions/BulkEdit.vue'

export const bulkActions = {
    process: {
        name: 'process',
        visualName: 'Process Files',
        requiresAdmin: true,
        component: 'MlRequestOptions',
        message: 'Process Files Request Complete',
    },
    delete: {
        name: 'delete',
        visualName: 'Delete Files',
        requiresAdmin: false,
        component: 'DeleteFilesButton',
        message: 'Files Deleted',
    },
    edit: {
        name: 'edit',
        visualName: 'Edit Files',
        requiresAdmin: false,
        component: 'BulkEdit',
        message: 'Files Edited Successfully',
    },
}

export default {
    name: 'BulkActionsManager',
    components: {MlRequestOptions, DeleteFilesButton, BulkEdit},
    props: {
        soundIds: {type: Array, default: []},
        requestingUser: {type: String, required: true},
        token: {type: String},
        activeBulkItem: {type: Object, default: null, required: true},
    },
    emits: ['bulkActionComplete'],
    methods: {
        actionComplete(action, event){
            this.$emit('bulkActionComplete', {
                action: action,
                apiResponse: event,
            })
        },
    },
}
</script>

